import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { profile } from '../data/projects';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const closeMenu = () => setMenuOpen(false);

  const goToSection = (sectionId) => (event) => {
    event.preventDefault();
    closeMenu();

    if (location.pathname === '/') {
      const section = document.getElementById(sectionId);
      window.history.replaceState(null, '', `/#${sectionId}`);
      section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    navigate(`/#${sectionId}`);
  };

  return <header className="site-header">
    <div className="nav-shell">
      <Link className="wordmark" to="/" onClick={closeMenu}>NM<span>.</span></Link>
      <button className="menu-button" type="button" aria-expanded={menuOpen} aria-controls="site-navigation" onClick={() => setMenuOpen((open) => !open)}>
        <span className="sr-only">{menuOpen ? 'Close' : 'Open'} navigation</span>
        <span aria-hidden="true">{menuOpen ? '×' : '☰'}</span>
      </button>
      <nav id="site-navigation" className={`site-nav ${menuOpen ? 'is-open' : ''}`} aria-label="Primary navigation">
        <a href="/#work" onClick={goToSection('work')}>Work</a>
        <a href="/#about" onClick={goToSection('about')}>About</a>
        <a href="/#contact" onClick={goToSection('contact')}>Contact</a>
        <a className="nav-resume" href={profile.resume} download="Ndurya_Muhammad_Resume">Resume ↗</a>
      </nav>
    </div>
  </header>;
}
